<template>
  <div class="wrapper">
    <div class="bg-card">
      <div class="d-flex justify-content-between">
        <strong>{{ $t('pages.user-cv.skills.title', 'Skills') }}</strong>
        <b-button
          class="cv-button"
          @click="$emit('skillsModalOpen')"
        >
          {{ $t('pages.user-cv.skills.edit-button', 'Edit skills') }}
        </b-button>
      </div>
      <hr>
      <div>
        <div v-if="skills">
          {{ $t('pages.user-cv.skills.my-skills', 'My skills') }}:
          <ul class="d-flex flex-wrap">
            <li
              v-for="skill in JSON.parse(skills)"
              :key="skill"
            >
              {{ skill }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    skills: {
      type: String,
      default: ""
    }
  }
}
</script>

<style lang="scss" scoped>
  ul {
    margin-bottom: 0;
  }

  ul li {
    padding: 0 15px;
    list-style: none;
  }

  ul li::before {
    content: "\2022";
    color: #009090;
    font-weight: bold;
    display: inline-block;
    width: 0.8em;
    margin-left: -1em;
  }
</style>
